import React from 'react';
import {
  GeckoBtnsSorted,
  GeckoCardBody,
  GeckoCardFooter,
  GeckoCardHeader,
  GeckoCardWrapper,
} from 'ui';
import PropTypes from 'prop-types';

const navigateToAuth = () => {
  window.open(`${process.env.REACT_APP_AUTH_URL}/account`);
};

const footerBtns = [
  {
    name: 'Manage My Account',
    handler: navigateToAuth,
  },
];

const ManageAccount = (props) => {
  if (props.agent_id !== props.loggedInUser.id) {
    return null;
  } else {
    return (
      <div className="Security Settings">
        <GeckoCardWrapper>
          <GeckoCardHeader name="Security Settings" />
          <GeckoCardBody padded>
            <h1>
              Update your <b>password</b>, turn on{' '}
              <b>two factor authentication</b> and view your{' '}
              <b>active sessions</b> through your account portal.
            </h1>
          </GeckoCardBody>
          <GeckoCardFooter>
            <GeckoBtnsSorted items={footerBtns} />
          </GeckoCardFooter>
        </GeckoCardWrapper>
      </div>
    );
  }
};

ManageAccount.propTypes = {
  agent_id: PropTypes.number.isRequired,
  loggedInUser: PropTypes.object.isRequired,
};

export default ManageAccount;
